import { appItem } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="bg-background-100 rounded-3xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-1/2 p-8 md:p-12 lg:p-16">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                移动端
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                {appItem.title}
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-6">
                {appItem.description}
              </p>
              <div className="flex flex-wrap gap-3 mb-8">
                {appItem.features.map((feat, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-50 border border-background-200/70 rounded-full text-sm text-foreground-700 whitespace-nowrap"
                  >
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                    {feat}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-3">
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white rounded-full font-medium text-sm transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-fill text-lg"></i>
                  App Store 下载
                </button>
                <button className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-white rounded-full font-medium text-sm transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-google-play-fill text-lg"></i>
                  Google Play 下载
                </button>
              </div>
            </div>
            <div className="lg:w-1/2 p-8 md:p-12 flex items-center justify-center bg-background-200/30">
              <div className="w-52 h-52 bg-background-50 rounded-2xl p-4 border border-background-200/70">
                <img
                  src={appItem.qrImage}
                  alt="扫码下载丁香花影院移动端"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}